import React from "react";
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../components/AuthLayout';
import { VerifyEmailForm } from '../components/VerifyEmailForm';
import { ResetPasswordForm } from '../components/ResetPasswordForm';
import { useNavigate } from 'react-router-dom';
import { paths } from 'routes';
import { useQueryParams } from 'hook/useQueryParams';

export const Action = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryParams = useQueryParams();

  const mode = queryParams.mode;
  const apiKey = queryParams.apiKey;
  const actionCode = queryParams.oobCode;

  const title = mode === 'resetPassword' ? t('website:auth.resetPassword.heading') : t('website:auth.verifyEmail.heading');

  return (
    <AuthLayout title={title}>
      {mode === 'resetPassword' && (
        <ResetPasswordForm actionCode={actionCode} onSuccess={() => navigate(paths.homepage)} />
      )}

      {mode === 'verifyEmail' && (
        <VerifyEmailForm apiKey={apiKey} actionCode={actionCode} onSuccess={() => navigate(paths.homepage)} />
      )}
    </AuthLayout>
  );
};
